import React from "react";
import Icon from "components/CommonIcon/Icon";
import ConditionalLink from "components/ConditionalLink";
import cx from "classnames";

export const MenuListItem = ({
  children,
  to,
  onClick,
  isHighlighted,
  ...props
}) => (
  <>
    {to ? (
      <ConditionalLink
        link={to}
        className={cx(
          "flex justify-between border-b border-gray-light font-semibold uppercase text-gray-text-2 pb-20 font-mulish tracking-16 text-hl-1",
          {
            "text-primary": isHighlighted,
          }
        )}
        activeClassName="text-primary"
        external={Boolean(props.newTab)}
        {...props}>
        {children}
        <Icon name="right-arrow-thin" />
      </ConditionalLink>
    ) : (
      <span
        className="flex justify-between border-b border-gray-light font-semibold uppercase text-gray-text-2 pb-20 font-mulish tracking-16 text-hl-1 cursor-pointer"
        onClick={onClick}>
        {children}
        <Icon name="right-arrow-thin" />
      </span>
    )}
  </>
);

const MenuList = ({ children }) => <div className="space-y-16">{children}</div>;

export default MenuList;
